import { render, staticRenderFns } from "./OrderGather.vue?vue&type=template&id=4285c74d&scoped=true&"
import script from "./OrderGather.vue?vue&type=script&lang=js&"
export * from "./OrderGather.vue?vue&type=script&lang=js&"
import style0 from "./OrderGather.vue?vue&type=style&index=0&id=4285c74d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4285c74d",
  null
  
)

export default component.exports